module.exports = __webpack_public_path__ + "img/sdg15_id.7b8dd961.svg";